import React from 'react';
import { styled } from '@linaria/react';
type Props = {
  type?: 'solid' | 'dashed';
};
const DashedGrid = /*#__PURE__*/styled('div')({
  name: "DashedGrid",
  class: "d1skjud4",
  propsAsIs: false
});
const Separator = /*#__PURE__*/styled('div')({
  name: "Separator",
  class: "sjdi7wl",
  propsAsIs: false
});
export const TimelineConnector = ({
  type = 'solid'
}: Props) => {
  if (type === 'solid') return <Separator />;
  if (type === 'dashed') return <>
        <DashedGrid />
        <DashedGrid />
        <DashedGrid />
        <DashedGrid />
      </>;
  return null;
};

require("./TimelineConnector.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./TimelineConnector.tsx");